import { setLastAttemptedRef } from '../app/utils/auth-utils';
(function () {
    'use strict';
    /**
     * Application Modules and Configuration
     */
    var archie = angular.module('archie', [
        'ngRoute',
        'ngMaterial',
        'angular.filter',
        'angularMoment',
        'archie.core',
        'ngAnimate',
        'ngMockE2E',
        'ngSanitize',
        //'infinite-scroll',
        /* video playback */
        'ng.deviceDetector',
    ]);
    archie.config(function ($logProvider) {
        $logProvider.debugEnabled(false);
    });
    archie.config(function ($mdThemingProvider) {
        var limeAccent = $mdThemingProvider.extendPalette('lime', {
            50: themeColors['accent-50'],
            200: themeColors['accent-200'],
            A200: '#FFC000',
            A400: themeColors['accent-A400'],
        });
        $mdThemingProvider.definePalette('limeAccent', limeAccent);
        var blueGreyBackground = $mdThemingProvider.extendPalette('grey', {
            50: themeColors['bg-50'],
            100: themeColors['bg-100'],
            200: themeColors['bg-200'],
            800: themeColors['bg-800'],
            A100: themeColors['bg-A100'],
            A200: themeColors['bg-A200'],
            A400: themeColors['bg-A400'],
            A700: themeColors['bg-A700'],
        });
        const extendedIndigo = $mdThemingProvider.extendPalette('indigo', {
            300: '#1990B7',
            500: '#1990B7',
            800: '#1990B7',
        });
        $mdThemingProvider.definePalette('indigo', extendedIndigo);
        $mdThemingProvider.definePalette('blueGreyBackground', blueGreyBackground);
        $mdThemingProvider
            .theme('default')
            .primaryPalette('indigo')
            .accentPalette('limeAccent')
            .backgroundPalette('blueGreyBackground');
    });
    archie.run(function () {
        document.title = appConfig.title;
    });
    angular.module('archie.core', []).controller('appController', [
        '$scope',
        '$window',
        'AuthService',
        'UserService',
        'TemplateService',
        'appContainerId',
        function ($scope, $window, AuthService, UserService, TemplateService, appContainerId) {
            $scope.appContainerId = appContainerId;
            $scope.feedBackEmail = appConfig.feedBackEmail == '' ? false : appConfig.feedBackEmail;
            $scope.supportToolLink = appConfig.supportToolLink;
            $scope.copyright = appConfig.copyright == '' ? false : appConfig.copyright;
            $scope.$watch(function () {
                return AuthService.isAuthenticated();
            }, function (isAuthenticated) {
                $scope.authenticated = isAuthenticated;
                if (isAuthenticated) {
                    // NOTE: don't delete may use in future
                    // get and set various site configurations
                    // HttpWrapperService.get('/configuration').then(function (response) {
                    // creative-work display templates
                    // TemplateService.setTemplates(response.data.templates);
                    // });
                    TemplateService.setTemplates();
                    $scope.ready = true;
                    console.log('scope is ready');
                }
                else {
                    $scope.ready = false;
                    console.log('scope not ready');
                }
            });
            $scope.displayApp = function () {
                return $scope.ready;
            };
            if (!AuthService.isDisabled()) {
                if (UserService.profile.token) {
                    console.log('user has profile token');
                    AuthService.tokenCheck().then(() => {
                        if (window.location.hash === '#/myidoptions') {
                            window.location = '#/video-dialogue';
                        }
                        setLastAttemptedRef($window);
                    });
                }
                else {
                    window.location = '#/myidoptions';
                }
            }
        },
    ]);
    // archie.run(function showVideoImprovementMessage($rootScope, AuthService, MessageConsole) {
    //     const STORAGE_MESSAGE_HIDDEN_KEY = 'showVideoImprovementMessage_hidden';
    //     let stopWatching = $rootScope.$watch(
    //         () => {
    //             if (!AuthService.isAuthenticated()) {
    //                 return false;
    //             }
    //             let alreadyShown;
    //             try {
    //                 alreadyShown = window.localStorage.getItem(STORAGE_MESSAGE_HIDDEN_KEY) === '1';
    //             } catch (e) {
    //                 return true;
    //             }
    //             if (alreadyShown) {
    //                 stopWatching();
    //                 return false;
    //             } else {
    //                 return true;
    //             }
    //         },
    //         (shouldShow) => {
    //             if (!shouldShow) {
    //                 return;
    //             }
    //             let messageData = {
    //                 type: 'n',
    //                 trustHtml: true,
    //                 msg: `
    //                 Our team has made improvements to VideoSearch.
    //                 If you experience any issues, we want to know.
    //                 Please click on the 'Report Bug'
    //                 <span class="md-24 material-icons">feedback</span>
    //                 link to report any problems`,
    //                 onHide: () => {
    //                     try {
    //                         window.localStorage.setItem(STORAGE_MESSAGE_HIDDEN_KEY, '1');
    //                     } catch (e) {}
    //                 },
    //             };
    //             MessageConsole.displayMessage(messageData);
    //             stopWatching();
    //         }
    //     );
    // });
})();
